var BackgroundComponent = /** @class */ (function () {
    function BackgroundComponent() {
        this.showLogo = true;
    }
    return BackgroundComponent;
}());
export { BackgroundComponent };
